// extracted by mini-css-extract-plugin
module.exports = {"nameCollection":"name-collection_nameCollection__M3yvY","collectionInfo":"name-collection_collectionInfo__ejdQD","progressbarWrapper":"name-collection_progressbarWrapper__4sfI1"};